import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Button, Input, Space, Row, Col, Select, Checkbox } from 'antd';
import { SaveOutlined } from "@ant-design/icons";
import { isMobile } from 'react-device-detect';
import BaseSelect from '@/components/Elements/BaseSelect';
import InputMask from "react-input-mask";
import moment from 'moment';
import { updateCustomer } from '@/redux/actions/customerActions';
import { _newLine, buildPhonesPayload, genderOptions, formatDateForInputMask, mergePhonesWithConfirmations } from '@/utils/helpers';
import { getListWards } from '@/redux/actions/regionsActions';
import PhoneDuplicateRelationModal from './PhoneDuplicateRelationModal';
import _ from 'lodash';
import BaseRadioList from '@/components/Elements/BaseRadios';
import CustomerRelationshipForm from './CustomerRelationshipForm';

class CustomerEditForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            wards: [],
            relationships: [],
            currentRelationships: [],

            phoneDuplicateModalVisible: false,
            phoneDuplicateData: {},
            pendingValues: null
        };
    }
    componentDidMount() {
        const { currentCustomer } = this.props;
        // Lấy dữ liệu từ currentCustomer nếu có sẵn
        if (currentCustomer) {
            this.updateStateFromCurrentItem(currentCustomer, {}); // Truyền {} làm prevCurrentItem để đảm bảo so sánh luôn khác
        }
    }

    componentDidUpdate(prevProps) {
        const { currentCustomer } = this.props;

        if (prevProps.currentCustomer !== currentCustomer) {
            this.updateStateFromCurrentItem(currentCustomer, prevProps.currentCustomer);
        }
    }

    updateStateFromCurrentItem = (currentCustomer, prevCurrentItem) => {
        if (!currentCustomer) return;

        const updates = {};

        const phonesStr = (currentCustomer?.phones || [])
            .map(p => p?.phone)
            .filter(Boolean);

        this.props.form.setFieldsValue({
            phones: phonesStr,
        });

        if (currentCustomer.relationships) {
            updates.currentRelationships = currentCustomer.relationships;
            updates.relationships = currentCustomer.relationships; //
        }

        this.setState(updates);

        // Gọi API lấy danh sách phường/xã nếu district_code thay đổi
        if (
            currentCustomer?.province_code &&
            currentCustomer.province_code !== prevCurrentItem?.province_code
        ) {
            this.props.getListWards({ province_code: currentCustomer.province_code }).then((res) => {
                this.setState({ wards: res.data });
            });
        }
    }

    async submit(e) {
        e.preventDefault();

        const { form } = this.props;
        const noPhone = form.getFieldValue('no_phone');

        // ÉP touched + validate other_contact khi submit
        if (noPhone) {
            form.setFields({
                other_contact: {
                    value: form.getFieldValue('other_contact'),
                    touched: true
                }
            });

            form.validateFields(['other_contact'], { force: true });
        }

        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true });

                try {
                    if (this.props.currentCustomer) {
                        const { relationships } = this.state;

                        const phonesRaw = values.phones || [];

                        // STEP 1: SOFT
                        const phonesSoft = buildPhonesPayload(phonesRaw);

                        const softPayload = {
                            ...values,
                            phones: phonesSoft,
                            mode: 'soft',
                            relationships: relationships
                        };

                        console.log('SUBMIT PAYLOAD (SOFT):', softPayload);

                        await this.props.updateCustomer(this.props.currentCustomer.id, softPayload);
                        this.onClose();
                    }
                } catch (error) {
                    const res = error?.response?.data;

                    // BACKEND SOFT DUPLICATE
                    if (res?.data?.type === 'PHONE_DUPLICATE_SOFT') {
                        this.setState({
                            phoneDuplicateModalVisible: true,
                            phoneDuplicateData: res.data.phones,
                            pendingValues: values,
                            isLoading: false,
                        });

                        return;
                    }

                    this.setState({ isLoading: false });
                }
            }
        });
    }

    handleSubmitHard = async (phonesConfirmedFromModal, customerRelationships) => {
        try {
            this.setState({ isLoading: true });

            const { pendingValues, relationships } = this.state;

            // 1. Lấy danh sách phone gốc user nhập
            const rawPhones = pendingValues.phones || [];

            // 2. MERGE phone gốc + xác nhận từ modal
            const phonesHard = mergePhonesWithConfirmations(
                rawPhones,
                phonesConfirmedFromModal
            );

            // 3. Merge family (giữ logic hiện tại của bạn – ĐÚNG)
            const mergedCustomerFamily = _.uniqBy(
                [...relationships, ...customerRelationships],
                'related_id'
            );

            const hardPayload = {
                ...pendingValues,
                phones: phonesHard,
                mode: 'hard',
                relationships: mergedCustomerFamily,
            };

            console.log('SUBMIT PAYLOAD (HARD):', hardPayload);

            await this.props.updateCustomer(this.props.currentCustomer.id, hardPayload);

            this.setState({
                phoneDuplicateModalVisible: false,
                phoneDuplicateData: {},
                pendingValues: null,
                isLoading: false,
            });

            this.onClose();
        } catch (error) {
            this.setState({ isLoading: false });
        }
    };

    handleClosePhoneDuplicateModal = () => {
        this.setState({
            phoneDuplicateModalVisible: false,
            phoneDuplicateData: {},
            pendingValues: null,
        });
    };

    onClose() {
        this.props.reloadData();
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({ isLoading: false });
    }

    loadWards(province_code) {
        if (province_code) {
            this.props.getListWards({ province_code: province_code }).then(res => {
                this.props.form.setFieldsValue({ ward_code: null });
                this.setState({ wards: res.data })
            })
        }
    }

    getRelationships = data => {
        this.setState({ relationships: data })
    }

    handleBirthdayChange = (e) => {
        const value = e.target.value;
        const date = moment(value, "DD/MM/YYYY", true);

        if (date.isValid()) {
            const age = moment().diff(date, "years");
            this.props.form.setFieldsValue({ age });
        } else {
            this.props.form.setFieldsValue({ age: "" });
        }
    };

    render() {
        var {
            wards,
            isLoading,
            currentRelationships,
        } = this.state;
        var {
            visible,
            currentCustomer,
            filterData
        } = this.props;

        const statuses = filterData.statuses;
        const sources = filterData.sources;
        const branches = filterData.branches;
        const interaction_types = filterData.interaction_types;
        const interaction_statuses = filterData.interaction_statuses;
        const provinces = filterData.provinces;

        const { getFieldError, isFieldTouched, getFieldValue, getFieldDecorator } = this.props.form;

        const noPhone = getFieldValue('no_phone');

        const phoneErrors = getFieldError('phones');
        const phoneTouched = isFieldTouched('phones');
        const showPhoneError = !noPhone && phoneTouched && phoneErrors && phoneErrors.length;

        const otherErrors = getFieldError('other_contact');
        const otherTouched = isFieldTouched('other_contact');
        const showOtherError = noPhone && otherTouched && otherErrors && otherErrors.length;

        return (
            <>
                <Drawer
                    visible={visible}
                    title={`${currentCustomer ? currentCustomer?.full_name : ""} - ${currentCustomer?.code}`}
                    onOk={(e) => this.submit(e)}
                    onClose={() => this.onClose()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '70%'}
                    footer={
                        <div style={{ textAlign: 'right', }}>
                            <Space>
                                <Button key="back" size='large' onClick={() => this.onClose()}>
                                    Huỷ
                                </Button>
                                <Button
                                    loading={isLoading}
                                    key="submit"
                                    type="primary"
                                    onClick={(e) => this.submit(e)}
                                    size='large'
                                    icon={<SaveOutlined />}
                                >
                                    Cập nhật
                                </Button>
                            </Space>
                        </div>
                    }
                >
                    {visible ?
                        <Form layout='vertical'>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Row gutter={16}>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Tên khách hàng">
                                                {getFieldDecorator('full_name', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng điền',
                                                        },
                                                    ],
                                                    initialValue: currentCustomer ? currentCustomer.full_name : null
                                                })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Nickname">
                                                {getFieldDecorator('fb_name', {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: 'Vui lòng điền',
                                                        },
                                                    ],
                                                    initialValue: currentCustomer ? currentCustomer.fb_name : null
                                                })(<Input disabled={currentCustomer.mode == 'from_message' ? true : false} />)}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Cơ sở">
                                                {getFieldDecorator('branch_id', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng chọn',
                                                        },
                                                    ],
                                                    initialValue: currentCustomer ? currentCustomer.branch_id : null,
                                                    normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                                })(
                                                    <BaseSelect
                                                        options={branches || []}
                                                        optionValue="id"
                                                        optionLabel="name"
                                                        defaultText="Chọn cơ sở"
                                                        placeholder="Chọn cơ sở"
                                                        className="w-100"
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={16}>
                                            <Form.Item
                                                label="Số điện thoại"
                                                validateStatus={showPhoneError ? 'error' : null}
                                                help={showPhoneError ? phoneErrors[0] : null}
                                            >
                                                {getFieldDecorator("phones", {
                                                    initialValue: (currentCustomer?.phones || [])
                                                        .map(p => p?.phone)
                                                        .filter(Boolean),
                                                    rules: noPhone
                                                        ? []
                                                        : [
                                                            {
                                                                required: true,
                                                                message: "Vui lòng nhập số điện thoại hoặc tích 'Khách không cung cấp SĐT'",
                                                            },
                                                        ],
                                                })(
                                                    <Select
                                                        mode="tags"
                                                        style={{ width: '100%' }}
                                                        placeholder="Nhập SĐT, cách nhau bằng dấu phẩy"
                                                        tokenSeparators={[',']}
                                                        open={false}
                                                        disabled={noPhone}
                                                    />
                                                )}
                                            </Form.Item>
                                            <Form.Item style={{ marginTop: -8 }}>
                                                {getFieldDecorator('no_phone', {
                                                    valuePropName: 'checked',
                                                    initialValue: !!currentCustomer?.no_phone,
                                                })(
                                                    <Checkbox
                                                        onChange={e => {
                                                            const checked = e.target.checked;

                                                            if (checked) {
                                                                // Tick: clear phones
                                                                this.props.form.setFields({
                                                                    phones: { value: [], errors: [] },
                                                                });

                                                                // (optional) đánh dấu other_contact để user nhập
                                                                // this.props.form.validateFields(['other_contact'], { force: true });
                                                            } else {
                                                                // Bỏ tick: clear other_contact
                                                                this.props.form.setFields({
                                                                    other_contact: { value: null, errors: [] },
                                                                });

                                                                // QUAN TRỌNG: ép phones bị "touched" để show lỗi ngay
                                                                this.props.form.setFields({
                                                                    phones: { value: this.props.form.getFieldValue('phones') || [], touched: true },
                                                                });

                                                                // ép validate lại phones theo rule required mới
                                                                this.props.form.validateFields(['phones'], { force: true });
                                                            }

                                                            this.forceUpdate();
                                                        }}
                                                    >
                                                        Khách không cung cấp số điện thoại
                                                    </Checkbox>
                                                )}
                                            </Form.Item>
                                            {noPhone && (
                                                <Form.Item
                                                    label="Phương thức liên hệ khác"
                                                    validateStatus={showOtherError ? 'error' : null}
                                                    help={showOtherError ? otherErrors[0] : null}
                                                >
                                                    {getFieldDecorator("other_contact", {
                                                        initialValue: currentCustomer?.other_contact || null,
                                                        rules: noPhone
                                                            ? [
                                                                {
                                                                    required: true,
                                                                    message: "Vui lòng nhập phương thức liên hệ khác (Facebook, Zalo, Email...)",
                                                                },
                                                            ]
                                                            : [],
                                                    })(
                                                        <Input placeholder="Ví dụ: Zalo, Facebook, Email..." />
                                                    )}
                                                </Form.Item>
                                            )}
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Giới tính">
                                                {getFieldDecorator("gender", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: "Vui lòng chọn",
                                                        },
                                                    ],
                                                    initialValue: currentCustomer ? currentCustomer.gender : null,
                                                    normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                                })(
                                                    <BaseRadioList
                                                        options={genderOptions || []}
                                                        placeholder="Chọn một bản ghi"
                                                        style={{ width: '100%' }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Nguồn">
                                                {getFieldDecorator("customer_source_id", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: "Vui lòng chọn",
                                                        },
                                                    ],
                                                    initialValue: currentCustomer ? currentCustomer.customer_source_id : null,
                                                    normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                                })(
                                                    <BaseSelect
                                                        options={sources || []}
                                                        optionValue="id"
                                                        optionLabel="name"
                                                        showSearch
                                                        placeholder="Chọn một bản ghi"
                                                        style={{ width: '100%' }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Năm sinh">
                                                {getFieldDecorator('birthday', {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: 'Vui lòng điền',
                                                        },
                                                    ],
                                                    initialValue: currentCustomer?.birthday ? formatDateForInputMask(currentCustomer.birthday, false) : '',
                                                    normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                                })(
                                                    <InputMask
                                                        mask="99/99/9999"
                                                        placeholder="dd/mm/yyyy"
                                                        onChange={e => {
                                                            this.handleBirthdayChange(e);
                                                        }}
                                                    >
                                                        {(inputProps) => <Input {...inputProps} />}
                                                    </InputMask>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Tuổi">
                                                {getFieldDecorator("age", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: "Vui lòng điền",
                                                        },
                                                    ],
                                                    initialValue: currentCustomer ? currentCustomer.age : null
                                                })(
                                                    <Input />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Mã số thẻ mới">
                                                {getFieldDecorator("card_number_new", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: "Vui lòng điền",
                                                        },
                                                    ],
                                                    initialValue: currentCustomer ? currentCustomer.card_number_new : null
                                                })(
                                                    <Input />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Mã số sổ khám">
                                                {getFieldDecorator("medical_book_number", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: "Vui lòng điền",
                                                        },
                                                    ],
                                                    initialValue: currentCustomer ? currentCustomer.medical_book_number : null
                                                })(
                                                    <Input />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Ghi chú">
                                        {getFieldDecorator('note', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền",
                                                },
                                            ],
                                            initialValue: currentCustomer ? _newLine(currentCustomer.note) : null
                                        })(
                                            <Input.TextArea rows={4} />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={8}>
                                    <Form.Item label='Trạng thái'>
                                        {getFieldDecorator("customer_status_id", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentCustomer ? currentCustomer.customer_status_id : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <BaseSelect
                                                options={statuses || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label='Loại tương tác'>
                                        {getFieldDecorator("interaction_type_id", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentCustomer ? currentCustomer.interaction_type_id : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <BaseSelect
                                                options={interaction_types || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label='Trạng thái tương tác'>
                                        {getFieldDecorator("interaction_status_id", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentCustomer ? currentCustomer.interaction_status_id : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <BaseSelect
                                                options={interaction_statuses || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col xs={24} md={8}>
                                    <Form.Item label="Link facebook">
                                        {getFieldDecorator("fb_link", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền!",
                                                },
                                            ],
                                            initialValue: currentCustomer ? currentCustomer.fb_link : null
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Link fanpage">
                                        {getFieldDecorator("fb_source", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền",
                                                },
                                            ],
                                            initialValue: currentCustomer ? currentCustomer.fb_source : null
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Tỉnh/Thành phố">
                                        {getFieldDecorator("province_code", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentCustomer ? currentCustomer.province_code : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <BaseSelect
                                                options={provinces || []}
                                                optionValue="code"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                                onChange={(code) => this.loadWards(code)}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Phường/Xa">
                                        {getFieldDecorator("ward_code", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentCustomer ? currentCustomer.ward_code : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <BaseSelect
                                                options={wards || []}
                                                optionValue="code"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Thôn, phố">
                                        {getFieldDecorator("hamlet", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentCustomer ? currentCustomer.hamlet : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Địa chỉ">
                                        {getFieldDecorator('address', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền!",
                                                },
                                            ],
                                            initialValue: currentCustomer ? currentCustomer.address : null
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16} className='mb-5'>
                                <Col xs={24} md={24}>
                                    <CustomerRelationshipForm currentData={currentRelationships} getItems={(data) => this.getRelationships(data)} />
                                </Col>
                            </Row>
                        </Form>
                        : null}
                </Drawer>

                <PhoneDuplicateRelationModal
                    visible={this.state.phoneDuplicateModalVisible}
                    duplicateData={this.state.phoneDuplicateData}
                    loading={isLoading}
                    onCancel={this.handleClosePhoneDuplicateModal}
                    onConfirm={({ phonesConfirmedFromModal, customerFamily }) => {
                        this.handleSubmitHard(phonesConfirmedFromModal, customerFamily);
                    }}
                />

            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        filterData: state.filterReducer.list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateCustomer: (id, data) => dispatch(updateCustomer(id, data)),
        getListWards: (filter) => dispatch(getListWards(filter))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerEditForm' })(CustomerEditForm));
